import React, { useState } from 'react';
import { airtableService } from '../services/airtable';

const DiagnosticPanel = () => {
  const [diagnostics, setDiagnostics] = useState({});
  const [running, setRunning] = useState(false);

  const runDiagnostics = async () => {
    setRunning(true);
    const results = {};

    // Check environment variables
    results.envVars = {
      hasApiKey: !!process.env.REACT_APP_AIRTABLE_API_KEY,
      hasBaseId: !!process.env.REACT_APP_AIRTABLE_BASE_ID,
      apiKeyLength: process.env.REACT_APP_AIRTABLE_API_KEY?.length || 0,
      baseIdFormat: process.env.REACT_APP_AIRTABLE_BASE_ID?.startsWith('app') || false
    };

    // Check localStorage
    const savedConfig = localStorage.getItem('airtable_config');
    results.localStorage = {
      hasConfig: !!savedConfig,
      configData: savedConfig ? JSON.parse(savedConfig) : null
    };

    // Check service initialization
    results.service = {
      isInitialized: airtableService.isInitialized,
      hasApiKey: !!airtableService.apiKey,
      hasBaseId: !!airtableService.baseId
    };

    // Try to initialize if not already
    if (!airtableService.isInitialized) {
      console.log('Attempting to initialize Airtable service...');
      results.initAttempt = airtableService.loadSavedConfig();
    }

    // Test table access if initialized
    if (airtableService.isInitialized) {
      try {
        console.log('Testing table access...');
        const testResult = await airtableService.setupTablesIfNeeded();
        results.tableSetup = { success: testResult };
      } catch (error) {
        results.tableSetup = { 
          success: false, 
          error: error.message,
          statusCode: error.statusCode 
        };
      }
    }

    setDiagnostics(results);
    setRunning(false);
  };

  const StatusIndicator = ({ status, label }) => (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      marginBottom: '8px',
      fontSize: '14px'
    }}>
      <span style={{ 
        width: '12px', 
        height: '12px', 
        borderRadius: '50%',
        backgroundColor: status ? '#4CAF50' : '#f44336',
        marginRight: '8px'
      }}></span>
      <span>{label}</span>
    </div>
  );

  return (
    <div style={{ 
      position: 'fixed', 
      top: '20px', 
      right: '20px', 
      width: '300px',
      backgroundColor: 'white',
      border: '2px solid var(--light-blue)',
      borderRadius: '8px',
      padding: '16px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
      zIndex: 1000,
      fontSize: '12px'
    }}>
      <h4 style={{ margin: '0 0 12px 0', color: 'var(--text-dark)' }}>
        🔍 Airtable Diagnostics
      </h4>
      
      <button 
        onClick={runDiagnostics}
        disabled={running}
        style={{
          padding: '6px 12px',
          border: 'none',
          borderRadius: '4px',
          backgroundColor: 'var(--primary-blue)',
          color: 'white',
          cursor: 'pointer',
          marginBottom: '12px',
          fontSize: '12px'
        }}
      >
        {running ? 'Running...' : 'Run Diagnostics'}
      </button>

      {Object.keys(diagnostics).length > 0 && (
        <>
          <div style={{ marginBottom: '12px' }}>
            <strong>Environment Variables:</strong>
            <StatusIndicator 
              status={diagnostics.envVars?.hasApiKey} 
              label="API Key Found" 
            />
            <StatusIndicator 
              status={diagnostics.envVars?.hasBaseId} 
              label="Base ID Found" 
            />
            <StatusIndicator 
              status={diagnostics.envVars?.baseIdFormat} 
              label="Base ID Format Valid" 
            />
          </div>

          <div style={{ marginBottom: '12px' }}>
            <strong>Service Status:</strong>
            <StatusIndicator 
              status={diagnostics.service?.isInitialized} 
              label="Service Initialized" 
            />
            <StatusIndicator 
              status={diagnostics.service?.hasApiKey} 
              label="Service Has API Key" 
            />
            <StatusIndicator 
              status={diagnostics.service?.hasBaseId} 
              label="Service Has Base ID" 
            />
          </div>

          {diagnostics.tableSetup && (
            <div style={{ marginBottom: '12px' }}>
              <strong>Table Setup:</strong>
              <StatusIndicator 
                status={diagnostics.tableSetup.success} 
                label="Tables Ready" 
              />
              {diagnostics.tableSetup.error && (
                <div style={{ 
                  color: '#f44336', 
                  fontSize: '11px', 
                  marginTop: '4px',
                  wordBreak: 'break-word'
                }}>
                  Error: {diagnostics.tableSetup.error}
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default DiagnosticPanel;